exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2-vSVkwl8eGBP79glukxW_{padding-top:10px;padding-right:2px;display:flex;flex-direction:column;align-items:center;justify-content:center}::-webkit-input-placeholder{text-align:left}input:-moz-placeholder{text-align:left}", ""]);

// exports
exports.locals = {
	"MapContainer": "_2-vSVkwl8eGBP79glukxW_"
};